// /src/utils/facebookPixel.ts
declare global {
  interface Window {
    dataLayer: any;
  }
}

export function googlePurchase(
  value: number,
  cartId: number,
  contentData: any
) {
  window.dataLayer.push({
    event: "transaction",
    ecommerce: {
      purchase: {
        actionField: {
          id: cartId, // Transaction ID. Required for purchases and refunds.
          affiliation: "Aqualens Store",
          revenue: value,
          tax: "0.00",
          shipping: "0.00",
        },
        products: contentData,
      },
    },
  });
}

export function googlePurchaseEvent(
  amount: any,
  payment_id: any,
  payment_mode:any,
  discount_code: any,
  order_item_array: any,
  order_content:any
) {

  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "purchase",
    ecommerce: {
      currency: "INR",
      payment_type:payment_mode,
      transaction_id:payment_id,
      value:amount,
      coupon:discount_code,
      order_content:order_content,
      items: order_item_array
    },
  });

}


// new events

export function viewCartEvent(
  order_item_array: any
) {
  // console.log('viewCartEvent','fdgfdgdfg satya',order_item_array);
  
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "view_cart",
    ecommerce: {
      currency: "INR",
      items: order_item_array,
    },
  });
}
export function addShippingInfoEvent(
  order_item_array: any
) {
  // console.log('addShippingInfoEvent','asdfghjkl 12345678');
  
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "add_shipping_info",
    ecommerce: {
      currency: "INR",
      items: order_item_array,
    },
  });
}


export function beginCheckoutEvent(
  order_item_array: any
) {
  // console.log(order_item_array,'begin_checkout');
  
  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "begin_checkout",
    ecommerce: {
      currency: "INR",
      items: order_item_array,
    },
  });
}

export function removeFromCartEvent(
  order_item_array: any
) {
// console.log(order_item_array,'remove_from_cart');

  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "remove_from_cart",
    ecommerce: {
      currency: "INR",
      items: order_item_array,
    },
  });
}


export function addPaymentInfoEvent(
  payment_mode:any,
  order_item_array: any
) {
  // console.log(order_item_array,'add_payment_info');

  window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  window.dataLayer.push({
    event: "add_payment_info",
    ecommerce: {
      currency: "INR",
      payment_type:payment_mode,
      items: order_item_array,
    },
  });
}


export function pushCartItem(tempCartItems: any[], cart_item_array: any[]) {
  if (tempCartItems && tempCartItems.length > 0) {
    for (let x = 0; x < tempCartItems.length; x++) {
      const tempCartItem = tempCartItems[x];
      let power_type = '';
      if (tempCartItem?.has_power == 1) {
        power_type = 'power';
      } else {
        power_type = 'zero power';
      }
      const filteredObj: any = {};
      Object.keys(tempCartItem).forEach(key => {
        if (tempCartItem[key] !== undefined) {
          filteredObj[key] = tempCartItem[key];
        }
      });

      let item_variant = '';
      if (tempCartItem?.variant_title == 'Default Title') {
        item_variant = 'Solution';
      } else {
        item_variant = tempCartItem?.variant_title;
      }

      cart_item_array.push({
        index: x,
        item_brand: 'Aqualens',
        ...(filteredObj.product_title !== undefined && { item_name: filteredObj.product_title }),
        ...(filteredObj.id !== undefined && { item_id: filteredObj.id }),
        ...(filteredObj.category_id !== undefined && { item_category: filteredObj.category_id }),
        ...(filteredObj.title !== undefined && { item_category2: filteredObj.title }),
        ...(filteredObj.subtitle !== undefined && { item_category3: filteredObj.subtitle }),
        ...(power_type !== undefined && { power_type }),
        ...(filteredObj.prescription?.left?.sph !== undefined && { sph_left_eye_power: filteredObj.prescription.left.sph }),
        ...(filteredObj.prescription?.right?.sph !== undefined && { sph_right_eye_power: filteredObj.prescription.right.sph }),
        ...(filteredObj.prescription?.left?.boxes !== undefined && { left_eye_boxes: filteredObj.prescription.left.boxes }),
        ...(filteredObj.prescription?.right?.boxes !== undefined && { right_eye_boxes: filteredObj.prescription.right.boxes }),
        ...(filteredObj.prescription?.left?.ap !== undefined && { additional_left_eye_power: filteredObj.prescription.left.ap }),
        ...(filteredObj.prescription?.right?.ap !== undefined && { additional_right_eye_power: filteredObj.prescription.right.ap }),
        ...(filteredObj.prescription?.left?.cyl !== undefined && { cyl_left_eye_power: filteredObj.prescription.left.cyl }),
        ...(filteredObj.prescription?.right?.cyl !== undefined && { cyl_right_eye_power: filteredObj.prescription.right.cyl }),
        ...(filteredObj.prescription?.left?.axis !== undefined && { axis_left_eye: filteredObj.prescription.left.axis }),
        ...(filteredObj.prescription?.right?.axis !== undefined && { axis_right_eye: filteredObj.prescription.right.axis }),
        ...(filteredObj.category_id !== undefined && { item_list_id: filteredObj.category_id }),
        // ...(filteredObj.variant_title !== undefined && { item_variant: filteredObj.variant_title }),
        ...(item_variant !== undefined && { item_variant }),
        ...(filteredObj.price !== undefined && { price: filteredObj.price }),
        ...(filteredObj.quantity !== undefined && { quantity: filteredObj.quantity }),
        ...(filteredObj.product_type !== undefined && { item_list_name: filteredObj.product_type }),

      });
    }
  }

  return cart_item_array;
}


export function pushCartItemPurchase(tempCartItems: any[], cart_item_array: any[]) {
  if (tempCartItems && tempCartItems.length > 0) {
    for (let x = 0; x < tempCartItems.length; x++) {
      const tempCartItem = tempCartItems[x];
      let power_type = '';
      if (tempCartItem?.has_power == 1) {
        power_type = 'power';
      } else {
        power_type = 'zero power';
      }
      const filteredObj: any = {};
      Object.keys(tempCartItem).forEach(key => {
        if (tempCartItem[key] !== undefined) {
          filteredObj[key] = tempCartItem[key];
        }
      });

      let item_variant = '';
      if (tempCartItem?.variant_title == 'Default Title') {
        item_variant = 'Solution';
      } else {
        item_variant = tempCartItem?.variant_title;
      }

      cart_item_array.push({
        index: x,
        item_brand: 'Aqualens',
        ...(filteredObj.product_title !== undefined && { item_name: filteredObj.product_title }),
        ...(filteredObj.id !== undefined && { item_id: filteredObj.id }),
        ...(filteredObj.category_id !== undefined && { item_category: filteredObj.category_id }),
        ...(filteredObj.title !== undefined && { item_category2: filteredObj.title }),
        ...(filteredObj.subtitle !== undefined && { item_category3: filteredObj.subtitle }),
        ...(power_type !== undefined && { power_type }),
        ...(filteredObj.prescription?.left?.sph !== undefined && { sph_left_eye_power: filteredObj.prescription.left.sph }),
        ...(filteredObj.prescription?.right?.sph !== undefined && { sph_right_eye_power: filteredObj.prescription.right.sph }),
        ...(filteredObj.prescription?.left?.boxes !== undefined && { left_eye_boxes: filteredObj.prescription.left.boxes }),
        ...(filteredObj.prescription?.right?.boxes !== undefined && { right_eye_boxes: filteredObj.prescription.right.boxes }),
        ...(filteredObj.prescription?.left?.ap !== undefined && { additional_left_eye_power: filteredObj.prescription.left.ap }),
        ...(filteredObj.prescription?.right?.ap !== undefined && { additional_right_eye_power: filteredObj.prescription.right.ap }),
        ...(filteredObj.prescription?.left?.cyl !== undefined && { cyl_left_eye_power: filteredObj.prescription.left.cyl }),
        ...(filteredObj.prescription?.right?.cyl !== undefined && { cyl_right_eye_power: filteredObj.prescription.right.cyl }),
        ...(filteredObj.prescription?.left?.axis !== undefined && { axis_left_eye: filteredObj.prescription.left.axis }),
        ...(filteredObj.prescription?.right?.axis !== undefined && { axis_right_eye: filteredObj.prescription.right.axis }),
        ...(filteredObj.category_id !== undefined && { item_list_id: filteredObj.category_id }),
        // ...(filteredObj.variant_title !== undefined && { item_variant: filteredObj.variant_title }),
        ...(item_variant !== undefined && { item_variant }),
        ...(filteredObj.price !== undefined && { price: filteredObj.price }),
        ...(filteredObj.quantity !== undefined && { quantity: filteredObj.quantity }),
        ...(filteredObj.product_type !== undefined && { item_list_name: filteredObj.product_type }),

      });
    }
  }

  return cart_item_array;
}

